module.exports = __webpack_public_path__ + "static/media/irish-defence-forces.c6603caa.png";